import { FloatingPanelContent } from "@babackapp/ui/components/floating-panel";
import { LucideProps } from "lucide-react";


export default function PanelInlineContent({ title, children, largeTitle, Icon }: {
	title: string;
	children: React.ReactNode,
	largeTitle?: boolean
	Icon?: React.FC<LucideProps>
}) {
	return (
		<FloatingPanelContent>
			<div className="flex flex-row items-center justify-between gap-2">
				<div className="items-center font-medium text whitespace-nowrap" style={{
					fontSize: largeTitle ? "0.875rem" : "0.7rem",
				}}>
					{Icon && <Icon className="inline mr-1" size={14} />}
					{title}
				</div>
				<div className="flex w-full justify-end">{children}</div>
			</div>
		</FloatingPanelContent>
	);
}
